import { Stack, TextInput, Text } from '@mantine/core';
import {
  useFormContext,
  useController,
  RegisterOptions,
} from 'react-hook-form';

interface FormInputProps {
  name: string;
  label: string;
  placeholder?: string;
  type?: string;
  description?: string;
  validation?: RegisterOptions;
  className?: string;
  [key: string]: any;
}

export function FormInput({
  name,
  label,
  placeholder,
  type = 'text',
  description,
  validation,
  ...rest
}: FormInputProps) {
  const { control } = useFormContext();
  const { field, fieldState } = useController({
    name,
    control,
    rules: validation,
  });

  const error = fieldState.error?.message;
  const isInvalid = !!error;

  return (
    <Stack gap='xs' w='100%'>
      <TextInput
        id={name}
        type={type}
        placeholder={placeholder}
        label={label}
        value={field.value || ''}
        onChange={field.onChange}
        onBlur={field.onBlur}
        error={error}
        aria-invalid={isInvalid}
        data-autofocus
        {...rest}
      />
      {description && (
        <Text size='xs' c='gray.6'>
          {description}
        </Text>
      )}
    </Stack>
  );
}
